import { useState } from "react";
import { Check, Share2 } from "lucide-react";
import { toast } from "@/components/ui/sonner";

export function ShareButton({ title, text, url, testId = "share-button" }) {
  const [copied, setCopied] = useState(false);

  async function copyLink() {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      toast.success("Profile link copied — post it anywhere");
      setTimeout(() => setCopied(false), 2200);
    } catch {
      toast.error("Copy failed — long-press the address bar instead");
    }
  }

  async function share() {
    if (navigator.share) {
      try {
        await navigator.share({ title, text, url });
        return;
      } catch (error) {
        if (error?.name === "AbortError") return;
      }
    }
    await copyLink();
  }

  return (
    <button data-testid={testId} onClick={share} className="inline-flex items-center gap-2 border border-gold/40 px-5 py-3 font-mono text-[11px] uppercase tracking-[0.22em] text-gold transition-colors hover:bg-gold hover:text-onyx">
      {copied ? <Check className="h-4 w-4" /> : <Share2 className="h-4 w-4" />}
      {copied ? "Copied" : "Share profile"}
    </button>
  );
}
